// extracted by mini-css-extract-plugin
module.exports = {"dialog":"_18184","title":"_7895","message":"_8684","actions":"_6200","item":"_12444","cancel":"_19335","confirm":"_1095","style2":"_6509"};